import { ReactNode, useCallback } from "react";
import styled from "styled-components";
import { WidgetRow } from "../PaddedRow";
import { useInputPopup } from "../../../components/InputPopup";
import PersonIcon from "../../../assets/svg/Person.svg?react";
import { ElidedText } from "@coworker/reusable/components/ElidedText";
import { UserOrGroupName } from "../UserOrGroupName";
import { Trans } from "@coworker/locales";

const TitleWrapper = styled.div`
  margin: 6px 0px;
`;

interface AreaSelectionProps {
  title?: ReactNode;
  selectedTeamId?: string | undefined;
  selectedUserId?: string | undefined;
  onConfirm: (assignee: { gid: string; uid: string }) => void;
  onClose?: () => void;
  image?: string | ReactNode;
  disabled?: boolean;
  showWarning?: boolean;
  testId?: string;
  disableTeamAssignment?: boolean;
  shortId?: string;
  additionalSubTitle?: React.ReactNode | undefined;
  tabIndex?: number;
}

export function AssigneeSelection({
  title = <Trans>assignString</Trans>,
  selectedTeamId,
  selectedUserId,
  onConfirm,
  onClose,
  image = <PersonIcon />,
  testId,
  shortId,
  disableTeamAssignment = false,
  additionalSubTitle,
  tabIndex = -1,
}: AreaSelectionProps) {
  const { getInput } = useInputPopup();
  const onClick = useCallback(
    () =>
      getInput("selectAssignees", {
        title,
        shortId,
        assignees: { gid: selectedTeamId, uid: selectedUserId },
        disableTeamAssignment,
      }).then((chosen: { gid: string; uid: string } | undefined) =>
        chosen ? onConfirm(chosen) : onClose?.()
      ),
    [
      disableTeamAssignment,
      onClose,
      onConfirm,
      title,
      shortId,
      getInput,
      selectedTeamId,
      selectedUserId,
    ]
  );

  return (
    <>
      <WidgetRow
        className="WidgetView"
        image={image}
        middle={
          <b>
            {selectedTeamId || selectedUserId ? (
              <ElidedText>
                <UserOrGroupName uid={selectedUserId} gid={selectedTeamId} />
              </ElidedText>
            ) : (
              <>
                <TitleWrapper>
                  <>{title}</>
                </TitleWrapper>
                {additionalSubTitle}
              </>
            )}
          </b>
        }
        right={<></>}
        onClick={onClick}
        testId={testId || "assignee-selection-widget"}
        disableRightArrow={true}
        tabIndex={tabIndex}
      />
    </>
  );
}
